import axios from "axios";

export function getStockTakeItemProductList(parameters) {
  return new Promise((resolve, reject) => {
    axios
      .get(`/distributor/admin/api/v1/stocktake/${parameters.id}/products`, {
        params: {
          length: parameters.length,
          start: parameters.start,
          search: parameters.search,
          order: parameters.order,
          order_by: parameters.order_by,
        },
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
